//  @flow
import { pickBy } from 'lodash'

export default (state: { resources: Object, meta: Object }, resources?: Object): { ... } => {
  const resourcesMeta = pickBy(state.meta, (resourceMeta) => resourceMeta.preDeleted)
  return pickBy(resources || state.resources, (resource, id: string) => resourcesMeta[id])
}
